import React from 'react'
import Loader from '../Loader'
import {
  LoginHeading,
  LoginButton,
  WhatAppInfoContainer,
  WhatAppCheckBox,
} from './styles'
import { PhoneInput } from '../FormComponents'
import WhatsappIcon from '../Images/WhatsappIcon'

const LoginPage = ({
  phone,
  phoneError,
  handleKeyPress,
  handleSmsLogin,
  handlePhoneInputChange,
  isValidPhoneNumber,
  isProcessing,
  whatsAppFlag,
}) => {
  return (
    <>
      <LoginHeading>Enter your mobile number</LoginHeading>
      <PhoneInput
        error={phoneError}
        type="text"
        value={phone}
        onKeyDown={(e) => handleKeyPress(e, !isProcessing, handleSmsLogin)}
        onChange={(text) => handlePhoneInputChange(text)}
      />

      <LoginButton
        id="login-handler"
        onClick={handleSmsLogin}
        disabled={!isValidPhoneNumber('+' + phone)}
      >
        {isProcessing ? <Loader size="sm" invertColor noPadding /> : 'continue'}
      </LoginButton>
      <WhatAppInfoContainer>
        <WhatAppCheckBox ref={whatsAppFlag} type="checkbox" defaultChecked />
        Get important updates on <WhatsappIcon /> Whatsapp
      </WhatAppInfoContainer>
    </>
  )
}

export default LoginPage
